import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1221bf42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert-block" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot dot-green" }, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("保障中 ")
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot dot-red" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("不在保")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "foot" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_alert_box = _resolveComponent("alert-box")!

  return (_openBlock(), _createBlock(_component_alert_box, {
    dataTitle: "选择人员",
    onClose: _ctx.close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.searchText,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
            placeholder: "查询员工姓名",
            style: {"width":"100%","height":"60px"},
            onChange: _ctx.getReportEjectList,
            onKeydown: _withKeys(_ctx.getReportEjectList, ["enter"])
          }, null, 8, ["modelValue", "onChange", "onKeydown"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_table, {
              ref: "multipleTable",
              data: _ctx.tableData,
              style: {"width":"100%"},
              "header-cell-class-name": "table-head",
              "row-style": { color: '#5E617D' },
              onSelectionChange: _ctx.handleSelectionChange,
              onSelectAll: _ctx.selectAll,
              onSelect: _ctx.select
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { type: "selection" }),
                _createVNode(_component_el_table_column, {
                  prop: "serveCompanyName",
                  "column-key": "date",
                  fixed: "",
                  width: "90",
                  label: "状态"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.is_active)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _hoisted_6))
                      : (_openBlock(), _createElementBlock("p", _hoisted_7, _hoisted_10))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  width: "120",
                  label: "姓名"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "idcard",
                  label: "身份证号"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "company_name",
                  label: "被派遣单位"
                })
              ]),
              _: 1
            }, 8, ["data", "onSelectionChange", "onSelectAll", "onSelect"]),
            _createVNode(_component_el_pagination, {
              currentPage: _ctx.pageNum,
              "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pageNum) = $event)),
              small: "",
              layout: "total, sizes, prev, pager, next",
              total: _ctx.total,
              "page-size": _ctx.pageSize,
              "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pageSize) = $event)),
              "page-sizes": [5, 30, 50, 100],
              class: "pagination",
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.getReportEjectList
            }, null, 8, ["currentPage", "total", "page-size", "onSizeChange", "onCurrentChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "btn-white alone",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            }, " 取 消 "),
            _createElementVNode("button", {
              class: "btn alone",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
            }, "确 定")
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
}